import consentManagerScript from '@/utils/consentManagerScript';

export default {
    data() {
        return {
            consentManagerId: process.env.VUE_APP_CONSENTMANAGER_ID,
            gtmId: process.env.VUE_APP_GTM_ID
        };
    },
    methods: {
        initConsentManager() {
            if (process.client && this.consentManagerId) {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    dataLayer.push(arguments);
                }

                gtag('consent', 'default', {
                    ad_storage: 'denied',
                    analytics_storage: 'denied',
                    wait_for_update: 500
                });

                dataLayer.push({
                    event: 'default_content'
                });

                consentManagerScript(window, this.consentManagerId);
            }
        },
        initGoogleTagManager() {
            if (process.client && this.gtmId) {
                window['dataLayer'] = window['dataLayer'] || [];
                window['dataLayer'].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                const f = document.getElementsByTagName('script')[0],
                    j = document.createElement('script');
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + this.gtmId;
                f.parentNode.insertBefore(j, f);
            }
        },
        pushEvent(eventName) {
            (window['dataLayer'] || []).push({
                event: eventName
            });
        }
    },
    created() {
        if (process.client) {
            this.initConsentManager();
            this.initGoogleTagManager();
        }
    }
};
